export const admin = 'admin';
export const guest = 'guest';
export const company = 'company';
export const employee = 'employee';
export const superadmin = 'superadmin';
export const individual = 'individual';
